export const getGoogleProfile = (accessToken: string) => {
  const url = `https://www.googleapis.com/oauth2/v2/userinfo?fields=email%2Cfamily_name%2Cgender%2Cgiven_name%2Chd%2Cid%2Clink%2Clocale%2Cname%2Cpicture%2Cverified_email`

  return fetch(url, {
    method: 'GET',
    headers: { Authorization: `Bearer ${accessToken}` }
  })
    .then((response) => {
      if (response.status === 401) {
        console.log(`getGoogleProfile: /oauth2/v2/userinfo authentication failure`);

        return null; //FIXME: try to get a new access_token if the current one has expired
      }

      if (response.status !== 200) {
        response
          .text()
          .then((text) => console.log('Fetch oauth2/v2/userinfo text', text));

        throw Error(`Error fetching google profile, status=${response.status}`);
      }

      return response.json()
    })
}